import { useNumberOfDigits } from "../../../utils/helpers";
import { Sector } from "../../../utils/lighthouseConstants";
import ErrorMessage from "../../genericComponents/ErrorMessage/ErrorMessage";
import InputField from "../../genericComponents/InputField/InputField";
import "./SectorAttribute.css";

interface SectorNumberAttributeProps {
    label: string;
    sector: Sector;
    attributeName: string;
    defaultValue: number;
    setValue: (value: number | string, sectorIndex: number) => void;
    errorMessage?: string;
    onFocus?: (value: string) => void;
    onBlur?: (value: string) => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    valueMultiplier?: number;
    decimalDigits?: number;
    unit?: string;
    min?: number;
    max?: number;
    step?: string;
    disabled?: boolean;
}

const SectorNumberAttribute = (props: SectorNumberAttributeProps) => {
    const {
        label,
        sector,
        attributeName,
        defaultValue,
        setValue,
        errorMessage,
        onFocus,
        onBlur,
        valueMultiplier,
        decimalDigits,
        unit,
        min,
        max,
        step,
        disabled = false,
    } = props;

    const value = (sector as any)[attributeName] ?? defaultValue;

    return (
        <div>
            <div className="sector-attribute">
                <span className="sector-label">{label}</span>
                <InputField
                    value={useNumberOfDigits(value / (valueMultiplier ?? 1), decimalDigits ?? 2).toString()}
                    inputFieldId={`${sector.index}-${attributeName}`}
                    label=""
                    onChange={(newValue) => {
                        setValue(Number.parseFloat(newValue) * (valueMultiplier ?? 1), sector.index);
                    }}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onMouseEnter={props.onMouseEnter}
                    onMouseLeave={props.onMouseLeave}
                    type="number"
                    hasError={Boolean(errorMessage)}
                    min={min}
                    max={max}
                    step={step ?? "any"}
                    disabled={disabled}
                />
                {unit ? <span className="sector-unit">{unit}</span> : null}
            </div>

            {errorMessage ? <ErrorMessage message={errorMessage} light /> : null}
        </div>
    );
};

export default SectorNumberAttribute;
